import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import config from "../../config";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Footer from "../shared/Footer";

function PaymentResponse() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [error, setError] = useState(null);

  const orderId = searchParams.get("order_id");

  useEffect(() => {
    if (!orderId) {
      setError("Missing order ID in URL.");
      setLoading(false);
      return;
    }

    const fetchTransactionStatus = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/GET_TRANSACTION_STATUS_BY_ORDER_ID`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ORDER_ID: orderId }),
          }
        );

        if (!response.ok) {
          const msg = await response.text();
          throw new Error(`Server responded with ${response.status}: ${msg}`);
        }

        const result = await response.json();
        console.log(result);
        const paymentstatus = result.data.PaymentStatus;
        setStatusData(result.data);
        sessionStorage.setItem("PaymentStatus", paymentstatus);
        // setLoading(false);
        let status = ''
        if (paymentstatus === "S") {
          status = 'SUCCESS';
        } else if (paymentstatus === "P") {
          status = 'PENDING';
        } else if (paymentstatus === "F") {
          status = 'FAILED';
        } else {
          status = '';
        }
        paymentActivity(status);

        if (paymentstatus === "P") {
          setLoading2(true);
        }
      } catch (err) {
        // setLoading(false);
        setError(err.message);
      }
      finally {
        setLoading(false);
      }
    };

    fetchTransactionStatus();
  }, [orderId]);

  const paymentActivity = async (paymenyStatus) => {
    const token = sessionStorage.getItem("tokenclassx");
    try {
      const response = await fetch(`${config.API_BASE_URL}/InsertLogDataStudentLogin`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ROLL_CODE: sessionStorage.getItem("rollcode"),
          ROLL_NO: sessionStorage.getItem("rollnumber"),
          CONTACT_NO: sessionStorage.getItem("phoneNumber"),
          ACTIVITY: paymenyStatus
        }),
      });

      if (response.ok) {
        const result = await response.json();
      } else {
        const error = await response.text();
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  }

  const getStatusStyles = (status) => {
    switch (status) {
      case "F":
        return {
          backgroundColor: "#dc3545",
          icon: "fa-times",
          label: "Payment Failed",
          buttonClass: "btn-danger",
        };
      case "P":
        return {
          backgroundColor: "#ffc107",
          icon: "fa-clock-o",
          label: "Payment Pending",
          buttonClass: "btn-warning",
        };
      default:
        return {
          backgroundColor: "#28a745",
          icon: "fa-check",
          label: "Payment Successful",
          buttonClass: "btn-success",
        };
    }
  };

  if (loading) {
    return (
      <div className="custom-loader-container">
        <div className="custom-loader"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center mt-5 text-danger">
        <h4>Error: {error}</h4>
      </div>
    );
  }

  const { backgroundColor, icon, label, buttonClass } = getStatusStyles(
    statusData?.PaymentStatus
  );

  return (
    <>
      {loading2 && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div
              className="content-wrapper"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh", backgroundColor: "#f8f9fa" }}
              >
                <div
                  className="card text-center"
                  style={{
                    padding: "40px",
                    borderRadius: "12px",
                    boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                    borderBottom: `5px solid ${backgroundColor}`,
                    width: "490px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor,
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      margin: "0 auto",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <i
                      className={`fa ${icon}`}
                      style={{ color: "white", fontSize: "32px" }}
                      aria-hidden="true"
                    ></i>
                  </div>

                  <h3 style={{ marginTop: "20px", marginBottom: "30px" }}>{label}</h3>

                  <div className="text-left" style={{ marginTop: "20px" }}>
                    <div className="d-flex justify-content-between mb-2">
                      <strong>Order ID</strong>{" "}
                      <span>{statusData?.OrderId || "-"}</span>
                    </div>
                    {statusData?.PaymentStatus !== "F" && (
                      <div className="d-flex justify-content-between mb-2">
                        <strong>Transaction ID</strong>{" "}
                        <span>{statusData?.BankTransactionNo || "-"}</span>
                      </div>
                    )}

                    <div className="d-flex justify-content-between mb-2">
                      <strong>Transaction Amount</strong>{" "}
                      <span>
                        {statusData?.TransactionAmount
                          ? `${statusData.TransactionAmount}/-`
                          : "-"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <strong>Transaction Date & Time</strong>{" "}
                      <span>{statusData?.ResponseDateTime || ""}</span>
                    </div>

                    <button
                      className={`btn ${buttonClass}`}
                      style={{ marginTop: "50px" }}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/dashboard");
                      }}
                    >
                      Back to Dashboard <i className="fa fa-arrow-right ml-2"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentResponse;
